import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { cls } from '@arco-design/mobile-utils';
import { ContextLayout } from '../context-provider';
import { isSupportWebkitLineClamp } from './utils/is';
import JsEllipsis from './components/js-ellipsis';
import NativeEllipsis from './components/native-ellipsis';
export * from './type';
/**
 * 文本缩略组件，支持多行缩略、富文本、自定义缩略符、尾字符过滤等。
 * @en Text ellipsis component supports multi-line abbreviations, rich text, custom abbreviations, tail character filtering, etc.
 * @type 数据展示
 * @type_en Data Display
 * @name 文本缩略
 * @name_en Ellipsis
 */

var Ellipsis = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      text = props.text,
      dangerouslyUseInnerHTML = props.dangerouslyUseInnerHTML,
      _props$maxLine = props.maxLine,
      maxLine = _props$maxLine === void 0 ? 1 : _props$maxLine,
      maxHeight = props.maxHeight,
      _props$ellipsis = props.ellipsis,
      ellipsis = _props$ellipsis === void 0 ? true : _props$ellipsis,
      _props$ellipsisNode = props.ellipsisNode,
      ellipsisNode = _props$ellipsisNode === void 0 ? '...' : _props$ellipsisNode,
      _props$collapseNode = props.collapseNode,
      collapseNode = _props$collapseNode === void 0 ? '' : _props$collapseNode,
      onCollapseNodeClick = props.onCollapseNodeClick,
      _props$endExcludes = props.endExcludes,
      endExcludes = _props$endExcludes === void 0 ? [] : _props$endExcludes,
      _props$reflowOnResize = props.reflowOnResize,
      reflowOnResize = _props$reflowOnResize === void 0 ? false : _props$reflowOnResize,
      onReflow = props.onReflow,
      onEllipsisNodeClick = props.onEllipsisNodeClick;
  var domRef = useRef(null);
  var jsEllipsisRef = useRef(null);
  var useNativeEllipsis = isSupportWebkitLineClamp() && maxHeight === void 0 && ellipsisNode === '...' && endExcludes.length === 0 && !onReflow && !onEllipsisNodeClick;
  useImperativeHandle(ref, function () {
    var _jsEllipsisRef$curren;

    return {
      dom: domRef.current,
      reflow: jsEllipsisRef == null ? void 0 : (_jsEllipsisRef$curren = jsEllipsisRef.current) == null ? void 0 : _jsEllipsisRef$curren.reflow
    };
  });
  return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
    var prefixCls = _ref.prefixCls;
    return /*#__PURE__*/React.createElement("div", {
      className: cls(prefixCls + "-ellipsis", className),
      ref: domRef
    }, useNativeEllipsis ? /*#__PURE__*/React.createElement(NativeEllipsis, {
      prefixCls: prefixCls + "-ellipsis",
      ellipsis: ellipsis,
      dangerouslyUseInnerHTML: dangerouslyUseInnerHTML,
      text: text,
      maxLine: maxLine,
      collapseNode: collapseNode,
      onCollapseNodeClick: onCollapseNodeClick
    }) : /*#__PURE__*/React.createElement(JsEllipsis, {
      ref: jsEllipsisRef,
      prefixCls: prefixCls + "-ellipsis",
      text: text,
      ellipsis: ellipsis,
      dangerouslyUseInnerHTML: dangerouslyUseInnerHTML,
      maxLine: maxLine,
      maxHeight: maxHeight,
      ellipsisNode: ellipsisNode,
      collapseNode: collapseNode,
      endExcludes: endExcludes,
      reflowOnResize: reflowOnResize,
      onReflow: onReflow,
      onEllipsisNodeClick: onEllipsisNodeClick,
      onCollapseNodeClick: onCollapseNodeClick
    }));
  });
});
export default Ellipsis;